import React from 'react';
import { Card, Row, Col, Form, Switch } from 'antd';
import { CompanySettings } from '../../../../types/company.types';

interface EmailSettingsFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  settings: CompanySettings;
  loading: boolean;
}

const EmailSettingsForm: React.FC<EmailSettingsFormProps> = ({ form, settings, loading }) => (
  <Card className="setting-card" title="E-posta Ayarları">
    <Row gutter={[24, 16]}>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="İzin İsteği E-postaları"
          name="sendMailLeave"
          valuePropName="checked"
          initialValue={settings.sendMailLeave}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Talep E-postaları"
          name="sendMailTicket"
          valuePropName="checked"
          initialValue={settings.sendMailTicket}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Form.Item
          label="Mazeret E-postaları"
          name="sendMailExcuse"
          valuePropName="checked"
          initialValue={settings.sendMailExcuse}
        >
          <Switch disabled={loading} />
        </Form.Item>
      </Col>
    </Row>
  </Card>
);

export default EmailSettingsForm;
